export function selectNotifications(state) {
    return state.notifications;
}
